import { render, staticRenderFns } from "./loginpassword.vue?vue&type=template&id=56ab07cf&scoped=true&"
import script from "./loginpassword.vue?vue&type=script&lang=js&"
export * from "./loginpassword.vue?vue&type=script&lang=js&"
import style0 from "./loginpassword.vue?vue&type=style&index=0&id=56ab07cf&less=true&scoped=true&lang=css&"
import style1 from "./loginpassword.vue?vue&type=style&index=1&less=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ab07cf",
  null
  
)

export default component.exports